import {createStyledAnimation} from '../create-styled-animation';
import {PropertyFlowDescription} from '../style-animation';
import {Duration, getDuration} from '../types';

export type SlideProps = {
	axis?: 'x' | 'y';
	from?: 'positive' | 'negative';
	distance?: number;
}

export function slideFlowBuilder(duration: Duration, flowProps: SlideProps): PropertyFlowDescription[] {
	const distance = `${flowProps.distance || 100}%`;
	const value = flowProps.from === 'negative' ? distance : '-' + distance;
	const direction = flowProps.axis === 'y' ? 'translateY' : 'translateX';
	const to = `${direction}(0)`;
	const from = `${direction}(${value})`;
	return [
		{
			name: 'transform',
			duration: getDuration(duration),
			from: from,
			to: to,
			initial: from,
			timingFunction: 'ease-in-out',
		},
	];
}

export const Slide = createStyledAnimation('Slide', slideFlowBuilder, ['axis', 'from']);
